import GroupEventList from './GroupEventList';

export default GroupEventList;
